import React, { useEffect } from 'react';
import './MobileDevelopment.css';
import fb from '../../assets/images/facebook.webp'
import twitter from '../../assets/images/twitter.webp'
import instagram from '../../assets/images/instagram.webp'
import linkedin from '../../assets/images/linkedin.webp'
import youtube from '../../assets/images/youtube.webp'
import pinterest from '../../assets/images/pinterest.webp'
import snapchat from '../../assets/images/snapchat.webp'
import be from '../../assets/images/be.webp'
import strong from '../../assets/images/strong.webp'

const MobileDevelopment = () => {


  

  useEffect(() => {
    // Position floating icons
    const social = document.querySelector('.md-social');
    const icons = document.querySelectorAll('.md-floating-icon');
    const leftIcons = [];
    const rightIcons = [];

    icons.forEach((icon, i) => {
      if (i % 2 === 0) leftIcons.push(icon);
      else rightIcons.push(icon);
    });

    const positionIcons = (array, horizontalStart, horizontalEnd, verticalRangeStart, verticalRangeEnd) => {
      const count = array.length;
      if (count === 0) return;
      const spacing = (verticalRangeEnd - verticalRangeStart) / (count + 1);
      array.forEach((icon, i) => {
        const horizontalPos = horizontalStart + Math.random() * (horizontalEnd - horizontalStart) * 0.1;
        icon.style.left = `${horizontalPos}%`;
        icon.style.right = 'auto';
        if (array === rightIcons) {
          icon.style.left = 'auto';
          icon.style.right = `${100 - horizontalPos}%`;
        }
        const topPos = verticalRangeStart + (i + 1) * spacing + (Math.random() * (spacing / 5) - spacing / 10);
        icon.style.top = `${topPos}%`;
        icon.style.animationDelay = `${Math.random() * 3}s`;
      });
    };

    positionIcons(leftIcons, 10, 30, 10, 90);
    positionIcons(rightIcons, 90, 100, 10, 100);

    const handleResize = () => {
      positionIcons(leftIcons, 10, 30, 10, 90);
      positionIcons(rightIcons, 90, 100, 10, 100);
    };

    window.addEventListener('resize', handleResize);

    // Animate on scroll with IntersectionObserver
    const animateOnScroll = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(animateOnScroll, { threshold: 0.1 });

    document.querySelectorAll('.md-benefit-item').forEach(item => observer.observe(item));
    document.querySelectorAll('.md-step').forEach(step => observer.observe(step));
    document.querySelectorAll('.md-feature-item').forEach(item => observer.observe(item));

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      observer.disconnect();
    };
  }, []);

 

  return (
    <>
      <section className="md-social" id="social">
        <h1>Mobile-App Development</h1>
        
        <h2>Involves designing, building, and deploying software applications specifically for mobile devices, enhancing user engagement and accessibility.</h2>
        <div className="md-icons">
          <img src={fb} alt="Facebook" className="md-floating-icon" />
          <img src={twitter} alt="Twitter" className="md-floating-icon" />
          <img src={instagram} alt="Instagram" className="md-floating-icon" />
          <img src={linkedin} alt="LinkedIn" className="md-floating-icon" />
          <img src={youtube} alt="YouTube" className="md-floating-icon" />
          <img src={pinterest} alt="Pinterest" className="md-floating-icon" />
          <img src={snapchat} alt="Snapchat" className="md-floating-icon" />
          <img src={be} alt="Behance" className="md-floating-icon" />
          <img src={strong} alt="Dribbble" className="md-floating-icon" />
        </div>
      </section>

      <section className="md-why-matters" id="why-matters">
        <div className="md-content">
          <h1>Why Mobile App Development Matters</h1>
          <p>Mobile applications have emerged as indispensable tools for businesses—empowering you to connect with customers on the go, streamline operations, and differentiate yourself in a fast-paced digital landscape. Whether you're nurturing a startup idea or scaling an established brand, a well-designed mobile app can significantly accelerate your goals.</p>
          <div className="md-benefits-grid">
            <div className="md-benefit-item">
              <div className="md-benefit-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Boost Customer Interaction</h3>
              <p>Foster deeper engagement by offering a seamless and mobile-first experience.</p>
            </div>
            <div className="md-benefit-item">
              <div className="md-benefit-icon">
                <i className="fas fa-globe"></i>
              </div>
              <h3>Accessible Anytime, Anywhere</h3>
              <p>Enhance user convenience and availability across devices.</p>
            </div>
            <div className="md-benefit-item">
              <div className="md-benefit-icon">
                <i className="fas fa-trophy"></i>
              </div>
              <h3>Stand Out from the Crowd</h3>
              <p>Gain a competitive edge through a tailored brand experience.</p>
            </div>
            <div className="md-benefit-item">
              <div className="md-benefit-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Unlock New Revenue Streams</h3>
              <p>Expand monetization opportunities with in-app purchases, subscriptions, and more.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="md-development-journey" id="development-journey">
        <h2>Our Development Journey</h2>
        <p>We believe great mobile applications are built through a clear, structured process. Here's how we transform your vision into reality:</p>
        <div className="md-journey-steps">
          <div className="md-step">
            <div className="md-step-icon">
              <i className="fas fa-pencil-ruler"></i>
            </div>
            <h3>Concept & Design (UI/UX)</h3>
            <p>Design intuitive, visually appealing interfaces that truly resonate with your audience's needs.</p>
          </div>
          <div className="md-step">
            <div className="md-step-icon">
              <i className="fas fa-code"></i>
            </div>
            <h3>Development & Coding</h3>
            <p>Engineer robust, scalable apps, whether native or cross-platform, tailored to your business requirements.</p>
          </div>
          <div className="md-step">
            <div className="md-step-icon">
              <i className="fas fa-bug"></i>
            </div>
            <h3>Quality Assurance & Testing</h3>
            <p>Rigorously test across devices and use cases to guarantee smooth performance and flawless functionality.</p>
          </div>
          <div className="md-step">
            <div className="md-step-icon">
              <i className="fas fa-tools"></i>
            </div>
            <h3>Deployment & Ongoing Support</h3>
            <p>Launch with confidence, and stay future-ready with consistent updates and maintenance.</p>
          </div>
        </div>
      </section>

      <section className="md-trusted-partner" id="trusted-partner">
        <h2>Partner with a Trusted Name</h2>
        <div className="md-partner-content">
          <div className="md-partner-text">
            <p>We are <strong>OAKYA IT SERVICES Pvt. Ltd.</strong>, your local, certified, and committed IT partner based in Vijayawada. We're devoted to simplifying tech for small businesses so you can focus on what truly matters.</p>
            <p>Based in Vijayawada, Andhra Pradesh, with a transparent and professional approach to every project.</p>
            <p>Responsive from concept to completion, your satisfaction is our priority.</p>
            {/* CTA */}
       <section className="mb-cta">
        <a className="mb-cta-btn" href="mailto:info@oakyaitservices.com">Book Your Free Consultation</a>
        </section>
          </div>
          
          <div className="md-features">
            <div className="md-feature-item">
              <h4><i className="fas fa-user-friends"></i> Human-Centered Design</h4>
              <p>We prioritize intuitive, user-focused experiences at every stage.</p>
            </div>
            <div className="md-feature-item">
              <h4><i className="fas fa-cogs"></i> Flexible Tech Solutions</h4>
              <p>From native to hybrid apps, we match technology precisely to your needs.</p>
            </div>
            <div className="md-feature-item">
              <h4><i className="fas fa-check-double"></i> Rigorous Testing</h4>
              <p>We deliver performances you can trust, without surprises.</p>
            </div>
            <div className="md-feature-item">
              <h4><i className="fas fa-headset"></i> Support & Evolution</h4>
              <p>We stay with you post-launch, keeping your app in top form.</p>
            </div>
            <div className="md-feature-item">
              <h4><i className="fas fa-map-marker-alt"></i> Local & Personal</h4>
              <p>Being based in Vijayawada means fast turnaround and easy communication.</p>
            </div>
          </div>
          
        </div>

        
                 

      </section>
    </>
  );
};

export default MobileDevelopment;